import ImageField from './component';

export default ImageField;
